import { ErrorMessage } from 'aa_common/front-end/antd'
import { If } from 'aa_common/front-end/components'
import InputNumber from 'aa_common/front-end/components/form/form-input-number'
import { Col, Row } from 'antd'
import { DEPRECIATION_METHOD_CODE } from 'common/constants'
import { useNextEffect } from 'common/hooks/use-next-effect'
import { getNs } from 'common/i18n-config'
import { LedgerSettingsItem } from 'common/models'
import Form from 'components/molecules/Form'
import { useFormContext } from 'react-hook-form'

import { useGetAssetLedger } from '../hooks/use-get-asset-ledger'
import { useIsFullImpairment } from '../hooks/use-is-full-impairment'
import { useResidualUsagePeriodDefault } from '../hooks/use-residual-usage-period-default'
import { SmallInputClass } from '../styles'
import { FIELD_NAMES } from '../validation'

const { t, useNsReady } = getNs(['components/organisms/assets/asset-impairment', 'common'])
const { FormField } = Form

const FieldName = FIELD_NAMES.impair_usage_period

type ResidualUsagePeriodProps = {
  ledgerSetting?: LedgerSettingsItem
}

export const ResidualUsagePeriod = ({ ledgerSetting }: ResidualUsagePeriodProps) => {
  useNsReady()
  const { setValue } = useFormContext()

  const assetLedger = useGetAssetLedger(ledgerSetting)
  const shouldShow =
    assetLedger?.depreciation_method_code &&
    [DEPRECIATION_METHOD_CODE.AVERAGE_USAGE_PERIOD, DEPRECIATION_METHOD_CODE.LEASE_PERIOD_STRAIGHT_LINE].includes(
      assetLedger?.depreciation_method_code
    )
  const disabled = useIsFullImpairment()
  const defaultValue = useResidualUsagePeriodDefault(assetLedger?.usage_period_months)

  useNextEffect(() => {
    setValue(FIELD_NAMES.impair_usage_period_maximum, assetLedger?.usage_period_months)
  }, [setValue, assetLedger?.usage_period_months])
  useNextEffect(() => {
    !shouldShow &&
      setValue(FieldName, null, {
        shouldValidate: true,
      })
  }, [setValue, shouldShow])
  useNextEffect(() => {
    shouldShow &&
      !disabled &&
      setValue(FieldName, defaultValue, {
        shouldValidate: true,
      })
    shouldShow &&
      disabled &&
      setValue(FieldName, null, {
        shouldValidate: true,
      })
  }, [setValue, shouldShow, disabled, defaultValue])

  return (
    <If condition={shouldShow}>
      <FormField title={t('residual_usage_period')} required>
        <Row align="middle" gutter={8}>
          <Col>
            <InputNumber
              min={1}
              name={FieldName}
              disabled={disabled}
              className={SmallInputClass}
              controls={false}
              isShowError={false}
            />
          </Col>
          <Col>
            <span>{t('residual_usage_period_unit')}</span>
          </Col>
        </Row>
        <ErrorMessage name={FieldName} errors={null} />
      </FormField>
    </If>
  )
}
